import { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import SessionManagement from './pages/SessionManagement';
import CharacterSheetLibrary from './pages/CharacterSheetLibrary';
import { SessionSetup } from './pages/SessionSetup';
import { SessionLive } from './pages/SessionLive';
import QRCodesPage from './pages/QRCodesPage';
import SettingsPage from './pages/SettingsPage';
import LoginPage from './pages/LoginPage';

const TOKEN_KEY = 'adminToken';

function AdminApp() {
  const [token, setToken] = useState<string | null>(null);
  const [isVerifying, setIsVerifying] = useState(true);

  useEffect(() => {
    // Check for existing token on mount
    const storedToken = localStorage.getItem(TOKEN_KEY);
    if (storedToken) {
      // Verify token is still valid
      fetch('/api/admin/verify', {
        headers: { Authorization: `Bearer ${storedToken}` },
      })
        .then((res) => {
          if (res.ok) {
            setToken(storedToken);
          } else {
            localStorage.removeItem(TOKEN_KEY);
          }
        })
        .catch(() => {
          localStorage.removeItem(TOKEN_KEY);
        })
        .finally(() => {
          setIsVerifying(false);
        });
    } else {
      setIsVerifying(false);
    }
  }, []);

  const handleLogin = (newToken: string) => {
    localStorage.setItem(TOKEN_KEY, newToken);
    setToken(newToken);
  };

  const handleLogout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
  };

  if (isVerifying) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500"></div>
      </div>
    );
  }

  if (!token) {
    return <LoginPage onLogin={handleLogin} />;
  }

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <Routes>
        <Route path="/" element={<Dashboard onLogout={handleLogout} />} />
        <Route path="/dashboard" element={<Dashboard onLogout={handleLogout} />} />
        <Route path="/sessions" element={<SessionManagement />} />
        <Route path="/session/:id" element={<SessionSetup />} />
        <Route path="/session/:id/live" element={<SessionLive />} />
        <Route path="/sheets" element={<CharacterSheetLibrary />} />
        <Route path="/qr-codes" element={<QRCodesPage />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Routes>
    </div>
  );
}

export default AdminApp;
